<app-modal [isOpen]="modalOpen" (close)="hide()">
    <p class="content">
        <strong [innerHtml]="text"> </strong>
    </p>
    <button (click)="hide()" class="btn" [attr.aria-label]="'OK' | translate" translate>OK</button>
</app-modal>
